import { environment } from '@env';
import { useApiFetch } from './useApiFetch';

export const useApiServiceTraining = () => {
  const fetchData = useApiFetch();

  const getProductline = async () =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/productline/`);

  const getProductfamily = async () =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/productfamily/`);

  const getAssemblies = async (assignedPL, drivenUnitTypes) => {
    let url = `${environment.BASE_URL}v1/dgs/assemblies/`;
    const params = new URLSearchParams();
    if (assignedPL) {
      params.append('assignedpl', String(assignedPL));
    }
    if (drivenUnitTypes) {
      params.append('drivenunittypes', String(drivenUnitTypes));
    }
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    return fetchData(url);
  };

  const getSubsystem = async datasource =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/${datasource}/subsystems`);

  const getDryGasSealTags = async (datasource, subsystemNames) => {
    let url = `${environment.BASE_URL}v1/dgs/assemblies/${datasource}/independent_tags`;
    if (Array.isArray(subsystemNames) && subsystemNames.length > 0) {
      url += `?SUBSYSTEM_NAME=${subsystemNames.join(',')}`;
    }
    return fetchData(url);
  };

  const getDGSInfo = async datasource =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/dgs_speed?DATASOURCE_ID=${datasource}`);

  const getOprSpeedInfo = async datasource =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/opr_speed?DATASOURCE_ID=${datasource}`);

  const getTimeSeriesChartData = async (from, to, datasource, tagAlias, frequency, businessRules) => {
    const requestBody = {
      DATASOURCE: datasource,
      TAG_ALIAS: tagAlias,
      DATA_FREQ: frequency,
      BUSINESS_RULE: businessRules
    };
    return fetchData(
      `${environment.BASE_URL}v1/dgs/timeseries/v3?from=${from}&to=${to}`,
      'POST',
      requestBody
    );
  };

  const trainModel = async ({
    tagName, tagAlias, datasource_id, frequency,
    startDate, endDate, businessRules, dgsInfo, name, desc
  }) => {
    const requestBody = {
      datasource_id,
      tag_alias: tagAlias,
      tag_name: tagName,
      st_date: startDate,
      end_date: endDate,
      data_freq: frequency,
      CUST_NAME: name,
      CUST_DESC: desc,
      business_rules: businessRules,
      DGS_Info: dgsInfo
    };
    return fetchData(`${environment.BASE_URL}v1/dgs/train/`, 'POST', requestBody);
  };

  const getMostImpactTags = async (tagAlias, datasource_id, frequency, startDate, endDate, businessRules) => {
    const requestBody = {
      DATASOURCE: datasource_id,
      TAG_ALIAS: tagAlias,
      DATA_FREQ: frequency,
      BUSINESS_RULE: businessRules
    };
    return fetchData(
      `${environment.BASE_URL}v1/dgs/most_impact_tags/?from=${startDate}&to=${endDate}`,
      'POST',
      requestBody
    );
  };

  const getActiveModels = async (tagAlias, datasource_id) => {
    let tag_alias_name;
    if (Array.isArray(tagAlias)) {
      tag_alias_name = [`[${tagAlias.map(t => `'${t}'`).join(', ')}]`];
    } else {
      tag_alias_name = [String(tagAlias)];
    }
    const requestBody = { datasource_id, tag_alias_name };
    const url = `${environment.BASE_URL}v1/dgs/train/models?status=ACTIVE&limit=60&offset=0`;
    return fetchData(url, 'POST', requestBody);
  };

  return {
    getProductline, getProductfamily, getAssemblies, getSubsystem,
    getDryGasSealTags, getTimeSeriesChartData, getDGSInfo,
    getOprSpeedInfo, trainModel, getMostImpactTags, getActiveModels
  };
};
